import Axios from 'axios';
import { SERVER_URL } from './constants';

import { PaymentData } from './types';

export async function verifyHmac(hmac: string, concatendatedString: string) {
  const data = {
    hmac,
    con: concatendatedString,
  };
  return Axios.post(`${SERVER_URL}/payment/verify_hmac`, data);
}

export async function generatePayment(data: PaymentData) {
  return Axios.post(`${SERVER_URL}/payment/generate_payment`, data);
}

export interface PaymentStatusPayload {
  id: string;
  orderId: string;
  intentionId: string;
  txId: string;
  success: boolean;
  pending: boolean;
  isFulfilled: boolean;
  createdAt: string;
}

export async function getPaymentStatus(params: {
  id?: string;
  orderId?: string;
}) {
  return Axios.get<{
    status: 'success' | 'error';
    message?: string;
    payment?: PaymentStatusPayload;
  }>(`${SERVER_URL}/payment/status`, { params });
}

export async function checkPayment(payment: {
  id: string;
  orderId: string;
  intentionId: string;
}) {
  return Axios.post(`${SERVER_URL}/payment/checkPayment`, payment);
}
